/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';

/**
 * トップページに表示されるポップアップバナー
 * @export
 * @interface PopupBannerModel
 */
export interface PopupBannerModel {
    /**
     * ポップアップバナーID
     * @type {number}
     * @memberof PopupBannerModel
     */
    contentPopupBannerId?: number;
    /**
     * ポップアップをクリックすると、遷移されるリンク先
     * @type {string}
     * @memberof PopupBannerModel
     */
    destinationUrl: string;
    /**
     * 
     * @type {ImageModel}
     * @memberof PopupBannerModel
     */
    image: ImageModel;
    /**
     * 公開開始日付のUNIX時間
     * @type {number}
     * @memberof PopupBannerModel
     */
    startDate?: number;
    /**
     * 公開終了日付のUNIX時間
     * @type {number}
     * @memberof PopupBannerModel
     */
    endDate?: number;
    /**
     * バナーが表示される曜日 *1,2,3,4,5,6,7: 月, 火, 水, 木, 金, 土, 日。
     * @type {string}
     * @memberof PopupBannerModel
     */
    displayWeekdays?: string;
}

/**
 * Check if a given object implements the PopupBannerModel interface.
 */
export function instanceOfPopupBannerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "destinationUrl" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

export function PopupBannerModelFromJSON(json: any): PopupBannerModel {
    return PopupBannerModelFromJSONTyped(json, false);
}

export function PopupBannerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopupBannerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentPopupBannerId': !exists(json, 'contentPopupBannerId') ? undefined : json['contentPopupBannerId'],
        'destinationUrl': json['destinationUrl'],
        'image': ImageModelFromJSON(json['image']),
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'displayWeekdays': !exists(json, 'displayWeekdays') ? undefined : json['displayWeekdays'],
    };
}

export function PopupBannerModelToJSON(value?: PopupBannerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contentPopupBannerId': value.contentPopupBannerId,
        'destinationUrl': value.destinationUrl,
        'image': ImageModelToJSON(value.image),
        'startDate': value.startDate,
        'endDate': value.endDate,
        'displayWeekdays': value.displayWeekdays,
    };
}

